export default __webpack_public_path__ + "static/media/2-750x500.3534f7b6.jpg";